
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"239","height":"304","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M188.589 327.668c-14.299-21.542-4.397-37.745 3.555-50.764 7.368-12.059 10.901-18.818 4.211-28.836-6.691-10.016-16.444-12.572-34.543-16.574-19.533-4.317-44.061-9.458-58.004-30.882-14.157-21.192-4.255-37.396 3.702-50.415 7.37-12.057 10.902-18.815 4.213-28.829-6.695-10.021-16.452-12.568-34.737-16.352-19.334-4.529-43.648-9.902-57.802-31.093-14.154-21.19-4.391-37.246 3.703-50.41 7.37-12.057 10.902-18.816 4.213-28.83C20.41-15.333 10.657-17.884-7.433-21.884-26.97-26.199-51.288-31.572-65.44-52.76c-14.152-21.188-4.25-37.391 3.708-50.407 7.37-12.056 11.043-18.752 4.213-28.828l35.44-11.215c14.15 21.186 4.248 37.389-3.71 50.405-7.37 12.056-10.902 18.814-4.216 28.826 6.698 10.024 16.454 12.571 34.536 16.566 19.536 4.32 43.854 9.693 58.004 30.878 14.155 21.19 4.254 37.392-3.902 50.622-7.17 11.846-10.847 18.757-3.716 28.753 6.4 9.89 16.155 12.437 34.237 16.432 19.541 4.32 43.851 9.691 58.004 30.878 14.154 21.191 4.254 37.392-3.46 50.519-7.613 11.949-11.059 18.747-4.455 28.725 6.691 10.021 16.447 12.573 34.542 16.573 19.536 4.316 43.85 9.693 57.909 30.989 14.252 21.087 4.351 37.29-3.602 50.31-7.367 12.058-10.901 18.818-4.211 28.835l-35.293 11.568z","fill":"#CE5640"}})])
          )
        }
      }
    